import { render } from "./EventAttendeesView.vue?vue&type=template&id=caef1598"
import script from "./EventAttendeesView.vue?vue&type=script&lang=js"
export * from "./EventAttendeesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__